import React from "react";
import PropTypes from 'prop-types';

import HintPopover from 'src/core/gd-ui/hint-popover/hint-popover'
import Classes from 'classnames';

export default class ToolbarButton extends React.Component {

    static propTypes = {
        name: PropTypes.string,
        gdIcon: PropTypes.string,
        hint: PropTypes.string,

        active: PropTypes.bool,

        onClick: PropTypes.func,
    }

    static defaultProps = {
        name: null,
        gdIcon: null,
        active: false,
        onClick: null,
    };

    onMouseDown = (e) => {
        e.preventDefault();
        if (this.props.onClick) this.props.onClick(this.props.name || "");
    }

    renderButton = () => {
        const classes = Classes('ui5-control-button s-26', this.props.gdIcon, {
            'selected': this.props.active
        });

        return (
            <div className={classes} tabIndex={-1} onMouseDown={this.onMouseDown}>
                {this.props.hint && <HintPopover parent={this} hint={this.props.hint} showDelay={600}/>}
            </div>
        );
    }

    render() {

        if (this.props.gdIcon) {
            return this.renderButton()
        }


        const classes = Classes('gd-draftail-toolbar-button', {
            'selected': this.props.active
        });

        return (
            <div className={classes} tabIndex={-1} onMouseDown={this.onMouseDown}>
                {typeof this.props.gdIcon !== "undefined" && this.props.gdIcon !== null &&
                <div className={Classes('gd-draftail-toolbar-button-icon', this.props.gdIcon)}/>}

                <HintPopover parent={this} hint={this.props.hint} showDelay={1000}/>
            </div>
        );
    }

    renderBACKUP() {
        const classes = Classes('gd-draftail-toolbar-button', {
            'selected': this.props.active
        });

        return (
            <div className={classes} tabIndex={-1} onMouseDown={this.onMouseDown}>
                {typeof this.props.gdIcon !== "undefined" && this.props.gdIcon !== null &&
                <div className={Classes('gd-draftail-toolbar-button-icon', this.props.gdIcon)}/>}

                <HintPopover parent={this} hint={this.props.hint} showDelay={1000}/>
            </div>
        );
    }
}
